import { defineStore } from 'pinia';

export const useUserInvitePopupStore = defineStore('userInvitePopup', {
	state: () => {
		return {
			isOpen: false,
			isOpenedFirstTime: false,
		};
	},
});
